import styled from 'styled-components';

export const CustomBanner = styled.img.attrs<{ left?: number; top?: number }>({
	className: 'icon-customFlag',
})`
	height: 40px;
	width: auto;
	position: absolute;
	top: ${(props: { left?: number; top?: number }) => (props.top ? props.top : 0)}px;
	left: ${(props: { left?: number; top?: number }) => (props.left ? props.left : 0)}px;
`;
